import { render } from "./BaseEmptyState.vue?vue&type=template&id=d0ebfec0&scoped=true"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js"

import "./BaseEmptyState.vue?vue&type=style&index=0&id=d0ebfec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ebfec0"]])

export default __exports__